import React, { useState, useEffect, useCallback } from 'react';
import Swal from 'sweetalert2';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ERegion } from '@opu/utils';
import AxiosInstance from '../../helpers/AxiosInstance';

// ? - implementing a reducer to fetch_all, search, filter_by_name

const useForm = (optionsToDisplay, handleOpen) => {
  const { detailsAction } = optionsToDisplay;

  const { t } = useTranslation();
  const getEstablishmentByRegion = (query) => AxiosInstance.get('/establishment', { params: { ...query } });

  const attributes = [{ name: 'name', title: t('table.establishment'), nestedObject: [], type: 'text', order: true }];

  const actions = {
    details: detailsAction && handleOpen,
  };

  return {
    attributes,
    actions,
    getEstablishmentByRegion,
  };
};

export default useForm;
